import React, { useState } from "react";

import { Paper, TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  Title,
  TableCellDefault,
  Loading,
  ModalDeleteConfirm,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables } from "App/hooks";
import {
  deleteInventoryControlByID,
  getByFilterInventory,
  headCells,
  ModalEditOQ,
  RESET_STATE_BARANG,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import { PencilIcon, SelectIcon, TrashIcon } from "App/Assets";
import {
  defaultToastError,
  formatNumber,
  defaultToastSuccess,
  isNull,
  formatRupiah,
} from "App/utils/helpers";

import FormFilterDaftarInventoryControl from "./FormFilterDaftarInventoryControl";
import {
  addBulkBarang,
  FreezeTable,
  InventoryKelolaDisplayBarang,
  useGetInventoryBarang,
} from "components/organism";

export default function DaftarInventoryControl() {
  const classes = STYLE_DEFAULT_MASTER();
  const [showAdd, setShowAdd] = useState(false);

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [inventoryID, setInventoryID] = useState(null);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [formBarang, setFormBarang] = useState(RESET_STATE_BARANG);
  const [showModalBarang, setShowModalBarang] = useState(false);

  const { listBarang } = useGetInventoryBarang(
    formFilter.gudang_id,
    formFilter.reload
  );

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
    formSearch = formFilter
  ) => {
    setLoading(true);

    const res = await getByFilterInventory(formSearch, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleClickAdd = () => {
    if (isNull(formFilter.gudang_id)) {
      defaultToastError("Pilih gudang terlebih dahulu");
    } else {
      setShowAdd(!showAdd);
    }
  };

  async function deleteList() {
    const res = await deleteInventoryControlByID(inventoryID);
    if (res.state) {
      defaultToastSuccess(res.message);
      await setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  const handleClickDelete = (row) => {
    setInventoryID(row.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  const handleBulkBarang = async (row) => {
    const response = await addBulkBarang(formFilter.gudang_id, row);
    if (response.state) {
      await setNewData();
      setShowAdd(false);
      const reload = formFilter.reload;
      setFormFilter({
        ...formFilter,
        reload: !reload,
      });
      return {
        state: true,
        message: response.message,
      };
    } else {
      return {
        state: false,
        message: response.message,
      };
    }
  };

  const handleClickSelect = (row) => {
      setFormBarang({
        id: row?.id,
        oq: formatRupiah(isNull(row?.oq) ? 0 : row.oq),
        name:row?.namaBarang,
        periode: formatRupiah(isNull(row?.periode) ? 0 : row?.periode),
        rata_rata: formatRupiah(isNull(row?.rata_rata) ? 0 : row?.rata_rata),
        stok_min: formatRupiah(isNull(row?.stok_min) ? 0 : row?.stok_min),
        stok_max: formatRupiah(isNull(row?.stok_max) ? 0 : row?.stok_max),
      });
      setShowModalBarang(!showModalBarang);
  };


  return (
    <>
    {showModalBarang && (
        <ModalEditOQ
          setShowModal={() => setShowModalBarang(false)}
          formBarang={formBarang}
          setFormBarang={setFormBarang}
          setNewData={setNewData}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          msg='Ini akan menghapus keseluruhan, apakah anda yakin?'
        />
      )}

      <div className={classes.root}>
        <Title title={"Daftar Inventory Control Perbekalan Farmasi"} />
        {showAdd && !isNull(formFilter.gudang_id) && (
          <InventoryKelolaDisplayBarang
            idGudang={formFilter.gudang_id}
            namaGudang={formFilter.gudang}
            rowsBarang={listBarang}
            callback={handleBulkBarang}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}>
          <FormFilterDaftarInventoryControl
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
            handleClickAdd={handleClickAdd}
          />
          <Loading show={loading} />
          <div className='mt-1'>
            <TableDaftarInventoryControl
              rows={rows}
              withAct={true}
              isDelete={true}
              handleClickUpdate={handleClickDelete}
              handleClickSelect={handleClickSelect}
              isSelect={true}
            />
            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </div>
        </Paper>
      </div>
    </>
  );
}

export const TableDaftarInventoryControl = ({
  rows,
  handleClickUpdate,
  handleClickSelect,
  withAct = true,
  isDelete = false,
  isSelect = false,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "namaBarang",
    orderByRow: ["namaBarang"],
  });

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}>
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow hover key={index}>
            <TableCell align='center'>{index + 1}</TableCell>
            <TableCell align='center'>
              {withAct ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "7px",
                  }}>
                    {isSelect ? (
                  <IconButtonDatatable onClick={() => handleClickSelect(row)}>
                      <PencilIcon width='12' height='12' fill='#fff' />
                  </IconButtonDatatable>
                    ) : (
                      <></>
                    )}
                  <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
                    {isDelete ? (
                      <TrashIcon />
                    ) : (
                      <SelectIcon width='16' height='16' fill='#fff' />
                    )}
                  </IconButtonDatatable>
                </div>
              ) : (
                <></>
              )}
            </TableCell>
            <TableCell align='left'>{row?.id}</TableCell>
            <TableCell align='left'>{row?.barang_id}</TableCell>
            <TableCell align='left'>{row?.namaBarang}</TableCell>
            <TableCell align='left'>{row?.namaGudang}</TableCell>
            <TableCell align='left'>{formatNumber(row?.hargapokok)}</TableCell>
            <TableCell align='right'>{formatNumber(row?.qty)}</TableCell>
            <TableCell align='right'>{row.hargapokok * row.qty}</TableCell>
            <TableCell align='right'>{formatNumber(row?.stok_min)}</TableCell>
            <TableCell align='right'>
              {formatNumber(row?.stok_max)}
            </TableCell>
            <TableCell align='right'>
              {formatNumber(row?.rata_rata)}
            </TableCell>
            <TableCell align='right'>
              {formatNumber(row?.oq)}
            </TableCell>
            <TableCell align='right'>
              {formatNumber(row?.periode)} Hari
            </TableCell>
            {/* <TableCell align='right'>
              {formatNumber(row?.nilaikritis)}
            </TableCell> */}
            <TableCellDefault row={row} type='custom' />
          </TableRow>
        );
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align='center' colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  );
};
